import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import configureStore from '../store/configureStore';
import { BrowserRouter, Route } from 'react-router-dom';
import { ScrollContext } from 'react-router-scroll-4';
import UI from '../features/ui';
import { fetchCustomEmojis } from '../actions/custom_emojis';
import { hydrateStore } from '../actions/store';
import { connectChatStream, connectUserStream } from '../actions/streaming';
import { IntlProvider, addLocaleData } from 'react-intl';
import { getLocale } from '../locales';
import { previewState as previewMediaState } from 'brighteon/features/ui/components/media_modal';
import { previewState as previewVideoState } from 'brighteon/features/ui/components/video_modal';
import { fetchAnnouncements } from '../actions/announcements';
import { fetchChatConversationUnreadCount } from '../actions/chat_conversations';
import initialState from '../initial_state';
import ErrorBoundary from '../components/error_boundary';

const { localeData, messages } = getLocale();
addLocaleData(localeData);

export const store = configureStore();
const hydrateAction = hydrateStore(initialState);

store.dispatch(hydrateAction);
store.dispatch(fetchCustomEmojis());
store.dispatch(fetchChatConversationUnreadCount());

export default class Brighteon extends React.PureComponent {

  static propTypes = {
    locale: PropTypes.string.isRequired,
  };

  componentDidMount() {
    this.disconnect = store.dispatch(connectUserStream());
    this.disconnectChat = store.dispatch(connectChatStream());
    store.dispatch(fetchAnnouncements());
  }

  componentWillUnmount() {
    if (this.disconnect) {
      this.disconnect();
      this.disconnectChat();
      this.disconnect = null;
      this.disconnectChat = null;
    }
  }

  shouldUpdateScroll(_, { location }) {
    return location.state !== previewMediaState && location.state !== previewVideoState;
  }

  render() {
    const { locale } = this.props;

    return (
      <IntlProvider locale={locale} messages={messages}>
        <Provider store={store}>
          <ErrorBoundary>
            <BrowserRouter basename='/web'>
              <ScrollContext shouldUpdateScroll={this.shouldUpdateScroll}>
                <Route path='/' component={UI} />
              </ScrollContext>
            </BrowserRouter>
          </ErrorBoundary>
        </Provider>
      </IntlProvider>
    );
  }

}
